import { LegalLayout } from "@/components/LegalLayout";
import { COMPANY } from "@/lib/company";

const sections = [
  {
    heading: "Objet et champ d'application",
    body: [
      `Les présentes Conditions Générales de Vente (CGV) régissent l'ensemble des prestations de services proposées par ${COMPANY.name}, exploité par ${COMPANY.owner}, ${COMPANY.status}, dont le siège est situé ${COMPANY.address}, immatriculé sous le SIRET ${COMPANY.siret} (ci-après « le Prestataire »).`,
      "Elles s'appliquent à toute commande de prestations de développement web et mobile, de maintenance, de suivi technique ou de consulting passée par un client professionnel ou particulier (ci-après « le Client »). Toute commande implique l'acceptation sans réserve des présentes CGV.",
    ],
  },
  {
    heading: "Devis et commande",
    body: [
      "Toute prestation fait l'objet d'un devis préalable, gratuit et personnalisé, établi par le Prestataire sur la base des besoins exprimés par le Client. Le devis est valable 30 jours à compter de sa date d'émission.",
      "La commande est réputée ferme et définitive à réception du devis daté et signé par le Client, accompagné du versement de l'acompte prévu à l'article 4. Toute modification du périmètre en cours de projet fera l'objet d'un avenant ou d'un devis complémentaire.",
    ],
  },
  {
    heading: "Prix",
    body: [
      "Les prix des prestations sont ceux indiqués sur le devis accepté. Ils sont exprimés en euros. En application de l'article 293 B du Code général des impôts, la TVA n'est pas applicable si le Prestataire relève du régime de la franchise en base de TVA ; à défaut, les prix s'entendent hors taxes, majorés de la TVA au taux en vigueur.",
    ],
  },
  {
    heading: "Modalités de paiement — acompte de 30 %",
    body: [
      "Un acompte de 30 % du montant total du devis est exigible à la commande. Le commencement des travaux est conditionné à l'encaissement effectif de cet acompte.",
      "Le solde, soit 70 % du montant total, est payable à la livraison de la prestation, à réception de la facture. Le paiement s'effectue par virement bancaire.",
      "Tout retard de paiement entraînera de plein droit l'application de pénalités de retard calculées au taux d'intérêt légal majoré, ainsi que, pour les clients professionnels, une indemnité forfaitaire de recouvrement de 40 € (articles L441-10 et D441-5 du Code de commerce).",
    ],
  },
  {
    heading: "Délais et livraison",
    body: [
      "Les délais de réalisation sont indiqués sur le devis à titre estimatif. Ils courent à compter de la réception de l'acompte et de l'ensemble des éléments nécessaires à la réalisation de la prestation (contenus, accès, validations).",
      "La livraison s'entend de la mise à disposition du livrable au Client (mise en ligne, remise des fichiers ou accès). Le Client dispose d'un délai de 7 jours à compter de la livraison pour formuler des réserves ; à défaut, la livraison est réputée acceptée.",
    ],
  },
  {
    heading: "Propriété intellectuelle",
    body: [
      "Le Prestataire demeure titulaire de l'ensemble des droits de propriété intellectuelle sur les livrables (code source, maquettes, documentation) jusqu'au paiement intégral du prix.",
      "Après complet paiement, les droits patrimoniaux d'exploitation sur les livrables spécifiquement développés pour le Client lui sont cédés, pour le monde entier et pour toute la durée légale de protection. Sont exclus de cette cession les outils, bibliothèques et composants génériques du Prestataire ainsi que les éléments sous licence de tiers (open source notamment), qui restent régis par leurs licences respectives.",
      "Le Prestataire est autorisé à mentionner la réalisation dans ses références commerciales, sauf opposition écrite du Client.",
    ],
  },
  {
    heading: "Garantie de 30 jours",
    body: [
      "Le Prestataire garantit les livrables contre tout dysfonctionnement (bug, anomalie de fonctionnement par rapport au cahier des charges validé) pendant une durée de 30 jours à compter de la livraison.",
      "Pendant cette période, les corrections d'anomalies sont réalisées sans frais supplémentaires. Sont exclues de la garantie : les anomalies résultant d'une modification du livrable par le Client ou un tiers, d'une mauvaise utilisation, d'une évolution des environnements techniques (navigateurs, OS, API tierces) ou toute demande d'évolution fonctionnelle nouvelle.",
      "Au-delà de cette période, les interventions font l'objet d'un contrat de maintenance ou d'un devis spécifique.",
    ],
  },
  {
    heading: "Responsabilité",
    body: [
      "La responsabilité du Prestataire est limitée aux dommages directs et prévisibles, et ne pourra excéder le montant total effectivement payé par le Client au titre de la commande concernée. Le Prestataire ne saurait être tenu responsable des dommages indirects (perte d'exploitation, perte de données, manque à gagner).",
    ],
  },
  {
    heading: "Droit de rétractation",
    body: [
      "Conformément à l'article L221-18 du Code de la consommation, le Client consommateur dispose d'un délai de 14 jours pour se rétracter d'un contrat conclu à distance. Toutefois, conformément à l'article L221-28, ce droit ne peut être exercé pour les prestations pleinement exécutées avant la fin du délai de rétractation avec l'accord exprès du consommateur.",
    ],
  },
  {
    heading: "Droit applicable et litiges",
    body: [
      "Les présentes CGV sont soumises au droit français. En cas de litige, les parties s'efforceront de trouver une solution amiable. À défaut, le litige sera porté devant les tribunaux compétents de Paris. Le Client consommateur peut recourir gratuitement à un médiateur de la consommation dans les conditions des articles L611-1 et suivants du Code de la consommation.",
      `Contact : ${COMPANY.email} — ${COMPANY.phone}.`,
    ],
  },
];

export default function CGV() {
  return (
    <LegalLayout
      testId="cgv-page"
      overline="Légal"
      title="Conditions Générales de Vente"
      updated="Juin 2026"
      sections={sections}
    />
  );
}
